import { Stagiaire } from '../types';
import StagiaireContactForm from './StagiaireContactForm';

export default function StagiaireContactModal({ stagiaire, onClose }: { stagiaire: Stagiaire; onClose: () => void; }) {
    return (
        <div className='modal-container active' onClick={onClose} style={{ zIndex: 9010 }}>
            <div className="stagiaire-modal" onClick={(e) => e.stopPropagation()}>
                <button className='modal-close' onClick={onClose}>&times;</button>
                <div className='stagiaire-modal__content'>
                    <h2 className='text-2xl'>Demande de rappel à {stagiaire.nomUsagePro}</h2>
                    <StagiaireContactForm stagiaire={stagiaire} />
                </div>
            </div>
        </div >
    );
}